<template>
  <div>
    <Edit
      :item="currentItem"
      :access="currentAccess"            
      :update="updateItem"      
      :close="closeEdit"
      :descSingular="descSingular"
    ></Edit>
    <div>
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <CTabs variant="tabs" class="nav-tabs-boxed">
            <CTab :title="descPlural">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Rede Social</th>
                      <th>Link</th>
                      <th>Visível Site</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in items">
                      <td>
                        <CIcon :name="'cib-'+item.rede_social"/>
                      </td>
                      <td>{{ item.link }}</td>
                      <td>
                        <span class="label success" v-if="item.visivel_site">Ativo</span>
                        <span class="label error" v-else>Inativo</span>
                      </td>
                      <td class="actions">
                        <button type="button" class="button button-primary" v-on:click="openEdit(item)"><fa-icon icon="pencil-alt" /></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CTab>
          </CTabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import clone from 'just-clone';
import { get, post, put, del } from '@/helpers/apiRequest';
import Edit from './Edit';

export default {
  name: 'sociais',
  components: {    
    Edit,
  },
  data() {
    return {
      descPlural: '',
      descSingular: '',
      loading: false,
      items: [],      
      modulos: [],
      currentItem: {},
      currentAccess: false,
    };
  },
  methods: {
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem('app'));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === 'ADMIN_SOCIAL'
      );
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    loadSociais() {
      this.loading = true;
      get('/admin/site-sociais')
        .then((json) => {
          this.items = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },    
    openEdit(item, showLoading = true) {
      this.currentItem = clone(item);
      if (showLoading) {
        this.loading = true;
      }
      get(`/admin/site-sociais/${this.currentItem.id}`).then((json) => {
        this.currentAccess = json;
        if (showLoading) {
          this.loading = false;
          this.$modal.show('sociaisEdit');
        }
      });
    },
    closeEdit() {
      this.$modal.hide('sociaisEdit');      
    },
    updateItem() {
      const { id } = this.currentItem;
      put(`/admin/site-sociais/${id}`, this.currentItem)
        .then((json) => {
          this.closeEdit();
          this.loadSociais();
          this.$swal({
            title: 'Salvo com sucesso',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });          
        })
        .catch((error) => {
          this.$swal({
            title: 'Falha ao Salvar',
            text: error.message,
            showCancelButton: true,
            cancelButtonText: 'Fechar',
            showConfirmButton: false,
            icon: 'error',
          });
        });
    },
  },
  beforeMount() {
    this.loading = true;
    this.loadSociais();
    this.loadDescricaoModulo();
  },
};
</script>
